import React from "react";

const Layout = ({ children, title }) => {
  return (
    <>
        <title>{title}</title>
        <meta name="description" content="Cloudmate - Your cloud solutions" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <main>{children}</main>
    </>
  );
};

export default Layout;
